import styles from "./style.module.css";
import React from 'react';
import { Briefcase, CheckCircle, Timer } from 'lucide-react';
import { lifeShackProductFacts } from '@src/config/productFacts';

const DashboardAnalytics = () => {
  const [isAutoApplyActive] = React.useState(true);
  const typicalUser =
    lifeShackProductFacts.approvedHomepageStatistics.typicalUser;

  const metrics = [
    {
      icon: <Briefcase className="w-5 h-5 text-white" />,
      label: "Jobs Queued",
      value: typicalUser.jobsQueued,
      trend: "+22"
    },
    {
      icon: <CheckCircle className="w-5 h-5 text-white" />,
      label: "Apps Submitted",
      value: typicalUser.applicationsSubmitted,
      trend: "30 days"
    },
    {
      icon: <CheckCircle className="w-5 h-5 text-white" />,
      label: "Jobs Evaluated",
      value: typicalUser.jobsEvaluated,
      trend: "7 days"
    },
    {
      icon: <Timer className="w-5 h-5 text-white" />,
      label: "Time Saved",
      value: `${typicalUser.hoursSaved} hrs`,
      trend: "30 days"
    }
  ];

  return (
    <div
      className={styles.mainCard}
      style={{
        maxWidth: "100%",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <div className="rounded-xl text-white">
          <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${isAutoApplyActive ? 'bg-green-400 animate-pulse' : 'bg-gray-400'}`}></div>
          </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8 mt-6">
            {metrics.map((metric, index) => (
              <div key={index} className="bg-white/10 rounded-lg p-3">
                <div className="flex items-center gap-2 mb-1">
                  {metric.icon}
                  <span className="text-sm font-medium">{metric.label}</span>
                </div>
                <div className="flex flex-col text-right md:text-left">
                  <span className="text-xl font-bold">{metric.value}</span>
                  <span className="text-xs text-indigo-200 mt-1">{metric.trend}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white/20 rounded-lg p-6 h-48 flex flex-col" style={{ marginBottom: "5px" }}>
            <h3 className={styles.chartTitle}>Applications Submitted</h3>
            <div className={styles.chartContainer}>
              <svg
                className={styles.chart}
                viewBox="0 0 560 150"
                preserveAspectRatio="none"
                role="img"
                aria-label="Applications submitted over the last seven days"
              >
                {[20, 55, 90, 125].map((y) => (
                  <line key={y} x1="34" y1={y} x2="552" y2={y} className={styles.gridLine} />
                ))}
                <polyline
                  points="34,104 120,88 206,96 292,57 378,68 464,42 552,28"
                  className={styles.chartLine}
                />
                {[34, 120, 206, 292, 378, 464, 552].map((x, index) => (
                  <circle
                    key={x}
                    cx={x}
                    cy={[104, 88, 96, 57, 68, 42, 28][index]}
                    r="3"
                    className={styles.chartPoint}
                  />
                ))}
              </svg>
            </div>
          </div>
          <p className={`${styles.disclaimer} text-xs text-gray-300 text-center mt-4`}>
            *This data reflects a typical user on the platform.
          </p>
      </div>
  </div>
  );
};

export default DashboardAnalytics;
